import React from 'react';
import {Box, IconButton, MenuItem, Select, Typography} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import './GridFooterPagination.scss';
import {t} from 'i18next';

const GridFooterPagination = ({
  page,
  pageCount,
  pageSize = 10,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
}: any) => {
  return (
    <Box className="grid-footer-pagination">
      <Typography className="label" data-testid={`grid-footer-pagination-per-page`}>
        {t(
          'productionsAndExports.createNewProduction.generate.modals.errors.perPage'
        )}
      </Typography>
      <Select
        size="small"
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
        className="page-size-select"
        MenuProps={{
          disablePortal: false,
          container: document.body,

          anchorOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          PaperProps: {
            style: {
              width: 2,
            },
          },
        }}
      >
        {pageSizeOptions.map((opt: number) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </Select>
      <Typography className="pages-label" data-testid={`grid-footer-pagination-pages`}>
        {t(
          'productionsAndExports.createNewProduction.generate.modals.errors.pages'
        )}
      </Typography>
      <Box className="page-numbers">
        {[...Array(pageCount)].map((_, index) => (
          <Typography
            key={index + 1}
            className={`page-number ${index === page ? 'active' : ''}`}
            onClick={() => onPageChange(index)}
            data-testid={`grid-footer-pagination-${index}`}
          >
            {index + 1}
          </Typography>
        ))}
      </Box>
      <Box className="nav-buttons">
        <Box>
          <IconButton
            size="small"
            onClick={() => onPageChange(page - 1)}
            disabled={page === 0}
            className="nav-button"
            data-testid={`grid-footer-pagination-previous`}
          >
            <ChevronLeftIcon className="nav-icon" />
          </IconButton>
        </Box>
        <Box>
          <IconButton
            size="small"
            onClick={() => onPageChange(page + 1)}
            disabled={page === pageCount - 1}
            className="nav-button"
            data-testid={`grid-footer-pagination-next`}
          >
            <ChevronRightIcon className="nav-icon" />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default GridFooterPagination;
